
import React from 'react';
import { AccountDeletionSection } from '@/components/settings/account';
import TwoFactorAuthSection from './TwoFactorAuthSection';
import { Separator } from '@/components/ui/separator';
import { Shield } from 'lucide-react';

const AccountTabContent: React.FC = () => {
  return (
    <div className="space-y-8">
      <div className="flex items-center gap-2 mb-4">
        <Shield className="text-primary h-6 w-6" />
        <h3 className="text-2xl font-medium">Account Settings</h3>
      </div>
      
      <Separator className="mb-6" />
      
      <section>
        <h3 className="text-lg font-medium mb-4">Security</h3>
        <TwoFactorAuthSection />
      </section>
      
      <Separator className="my-6" />
      
      <section>
        <h3 className="text-lg font-medium mb-4">Danger Zone</h3>
        <AccountDeletionSection />
      </section>
    </div>
  );
};

export default AccountTabContent;
